/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Heading_Contact_Upwork_PrefixInputs */

const en_heading_contact_upwork_prefix = /** @type {(inputs: Heading_Contact_Upwork_PrefixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hire`)
};

const ar_heading_contact_upwork_prefix = /** @type {(inputs: Heading_Contact_Upwork_PrefixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`توظيف`)
};

const bn_heading_contact_upwork_prefix = /** @type {(inputs: Heading_Contact_Upwork_PrefixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`হায়ার`)
};

const de_heading_contact_upwork_prefix = /** @type {(inputs: Heading_Contact_Upwork_PrefixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Beauftrage mich`)
};

const es_heading_contact_upwork_prefix = /** @type {(inputs: Heading_Contact_Upwork_PrefixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contrata`)
};

const fr_heading_contact_upwork_prefix = /** @type {(inputs: Heading_Contact_Upwork_PrefixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Recrutez`)
};

const pt_heading_contact_upwork_prefix = /** @type {(inputs: Heading_Contact_Upwork_PrefixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contrate`)
};

const zh_heading_contact_upwork_prefix = /** @type {(inputs: Heading_Contact_Upwork_PrefixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`雇用`)
};

const tr_heading_contact_upwork_prefix = /** @type {(inputs: Heading_Contact_Upwork_PrefixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`İşe Al`)
};

const ru_heading_contact_upwork_prefix = /** @type {(inputs: Heading_Contact_Upwork_PrefixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Нанять`)
};

const pl_heading_contact_upwork_prefix = /** @type {(inputs: Heading_Contact_Upwork_PrefixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zatrudnij`)
};

/**
* | output |
* | --- |
* | "Hire" |
*
* @param {Heading_Contact_Upwork_PrefixInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const heading_contact_upwork_prefix = /** @type {((inputs?: Heading_Contact_Upwork_PrefixInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Heading_Contact_Upwork_PrefixInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_heading_contact_upwork_prefix(inputs)
	if (locale === "bn") return bn_heading_contact_upwork_prefix(inputs)
	if (locale === "de") return de_heading_contact_upwork_prefix(inputs)
	if (locale === "es") return es_heading_contact_upwork_prefix(inputs)
	if (locale === "fr") return fr_heading_contact_upwork_prefix(inputs)
	if (locale === "pt") return pt_heading_contact_upwork_prefix(inputs)
	if (locale === "zh") return zh_heading_contact_upwork_prefix(inputs)
	if (locale === "tr") return tr_heading_contact_upwork_prefix(inputs)
	if (locale === "ru") return ru_heading_contact_upwork_prefix(inputs)
	if (locale === "pl") return pl_heading_contact_upwork_prefix(inputs)
	return en_heading_contact_upwork_prefix(inputs)
});